import { create } from 'zustand'

interface MobileFullscreenState {
  /** True when a full-screen overlay (WorkFullscreen, AgendaFullView) is active */
  isFullscreenActive: boolean
  setFullscreenActive: (active: boolean) => void
}

/**
 * Global state for tracking when a mobile full-screen view is active.
 * Used by Tabs.tsx to hide the nav bar on mobile when overlays are displayed.
 */
export const useMobileFullscreen = create<MobileFullscreenState>((set) => ({
  isFullscreenActive: false,
  setFullscreenActive: (active) => set({ isFullscreenActive: active }),
}))
